import { createSelector } from 'reselect';
import { descend, filter, prop as rProp, slice, sortWith } from 'ramda';

import { createFilter } from './FilterUtil';

const getResults = state => state.entities.results.items;
const getResultsFilter = state => state.entities.results.filter;
const getResultsPagination = state => state.entities.results.pagination;
const getCurrentResultCommon = state => state.entities.results.currentResult;

const strMatchesFilter = (str, filter) => str && str.indexOf(filter) > -1;
const resultMatchesFilter = (r, filter) =>
  !filter ||
  strMatchesFilter(r.participant.firstName, filter) ||
  strMatchesFilter(r.participant.lastName, filter) ||
  strMatchesFilter(r.participant.email, filter) ||
  strMatchesFilter(r.project.company.name, filter) ||
  strMatchesFilter(r.project.company.slug, filter) ||
  strMatchesFilter(r.project.company.id, filter) ||
  strMatchesFilter(r.project.name, filter) ||
  strMatchesFilter(r.project.slug, filter) ||
  strMatchesFilter(r.project.id, filter) ||
  strMatchesFilter(r.project.activity.name, filter) ||
  strMatchesFilter(r.status, filter);

export const getResultsFiltered = createSelector([getResults, getResultsFilter], (results, filterValue) => {
  return filterValue
    ? filter(createFilter(filterValue, resultMatchesFilter), results)
    : results;
});

export const getResultsFilteredPage = createSelector(
  [getResultsFiltered, getResultsPagination],
  (filtered, { page, size }) => {
    const sorted = sortWith([descend(rProp('statusTimestamp')), descend(rProp('id'))], filtered);
    return {
      items: slice(page * size, (page + 1) * size, sorted),
      page: page,
      size: size,
      totalSize: sorted.length
    };
  }
);

export const getCurrentResult = createSelector([getCurrentResultCommon], (currentResult) => {
  return {
    ...currentResult,
    events: sortWith([descend(rProp('timestamp'))], currentResult.events || [])
  };
});



// WEBPACK FOOTER //
// ./src/selectors/ResultsSelector.js